export default "__VITE_ASSET__7414837d__"